import React, { useEffect, useState } from 'react';
import { useLoader, useUserRole } from '../../../../../hooks';
import { get as lodashGet, set as lodashSet, keys as lodashKeys, set } from 'lodash';
import { toast } from 'react-toastify';
import allDeviceClasses from '../../../../../styles/AllDevices.module.css';
import { Form, Formik } from 'formik';
import Dropdown from '../../../../../components/Inputs/Dropdown';
import { Input } from '../../../../../components/Inputs/Input';
import Typography from '../../../../../components/Typography/Typography';
import MultiSelectDropdown from '../../../../../components/Inputs/MultiSelectDropdown';
import { RootInstanceBundleService } from '../../../../../services/BiddingService/Root/InstanceBundleService';
import { AdminInstanceBundleService } from '../../../../../services/BiddingService/Admin/InstanceBundleService';
import { SymetricalBundleValidation } from '../../../../../validations/SymetricalBundle/SymetricalBundle';
import { SymetricalBundleService } from '../../../../../services/BiddingService/CommonServices/SymetricalBundleService';

const MARKET_OPTION = [
    {
        label: 'aFRR',
        value: 'aFRR',
    },
    {
        label: 'mFRR',
        value: 'mFRR',
    },
];

const AREA_OPTION = [
    {
        label: 'DK1',
        value: 'DK1',
    },
    {
        label: 'DK2',
        value: 'DK2',
    },
];

const TYPE_OPTION = [
    {
        label: 'Distributed',
        value: 'Distributed',
    },
    {
        label: 'Co-located',
        value: 'Co-located',
    },
];

export const CreateSymetricalBundle = ({ admins = [], editBundle = null, setOpen, getSymetricalBundles }) => {
    const { isRootUser, isAdminUser, adminId } = useUserRole();
    admins = admins.filter((a) => a.value !== 'all');
    const service = isRootUser ? RootInstanceBundleService : AdminInstanceBundleService;

    const [startLoader, stopLoader] = useLoader();
    const [initialValues, setInitialValues] = useState({
        name: lodashGet(editBundle, ['name'], ''),
    });
    const [selectedMarket, setSelectedMarket] = useState(editBundle ? { value: editBundle.market } : MARKET_OPTION[0]);
    const [selectedArea, setSelectedArea] = useState(editBundle ? { value: editBundle.area } : AREA_OPTION[0]);
    const [selectedAdmin, setSelectedAdmin] = useState(editBundle ? { value: editBundle.adminId } : isAdminUser ? { value: adminId } : lodashGet(admins, 0));
    const [incInsBundles, setIncInsBundles] = useState([]);
    const [selectedIncInsBundles, setSelectedIncInsBundles] = useState(editBundle ? editBundle?.incInstanceBundle?.map((el) => ({ value: el })) : []);
    const [decInsBundles, setDecInsBundles] = useState([]);
    const [selectedDecInsBundles, setSelectedDecInsBundles] = useState(editBundle ? editBundle?.decInstanceBundle?.map((el) => ({ value: el })) : []);
    const [selectedType, setSelectedType] = useState(editBundle ? { value: editBundle.type } : TYPE_OPTION[0]);

    useEffect(() => {
        if (selectedMarket.value && selectedArea.value && selectedAdmin.value) getInsBundles();
    }, [selectedAdmin.value, selectedMarket.value, selectedArea.value]);

    const getInsBundles = () => {
        const params = {
            market: selectedMarket.value,
            area: selectedArea.value,
            adminId: selectedAdmin.value,
        };

        service.GetInstanceBundleForSymetricalBundle(params, startLoader, handleInsBundleSuccess, handleError, stopLoader);
    };

    const handleInsBundleSuccess = ({ data }) => {
        const inc = [];
        const dec = [];
        lodashGet(data, ['data'], []).map((el) => {
            if (el.market.includes('INC')) inc.push({ label: el.name, value: el._id });
            else dec.push({ label: el.name, value: el._id });
        });

        setIncInsBundles(inc);
        setDecInsBundles(dec);
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    const handleSubmit = (values) => {
        const payload = {
            ...values,
            ...(isAdminUser ? { adminId } : {}),
            incInstanceBundle: lodashGet(values, ['incInsBundles'], []).map((el) => el.value),
            decInstanceBundle: lodashGet(values, ['decInsBundles'], []).map((el) => el.value),
            type: selectedType.value,
        };
        if (!editBundle) SymetricalBundleService.Create(payload, startLoader, handleSuccess, handleError, stopLoader);
        else SymetricalBundleService.Update(editBundle._id, payload, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = () => {
        toast.success(`Bundle ${editBundle ? 'updated' : 'created'} successfuly`);
        setOpen({ status: false, editBundle: null });
        getSymetricalBundles();
    };

    return (
        <div style={{ width: '30vw', overflow: 'initial' }}>
            <Typography content={`${editBundle ? 'Edit' : 'Create'} Linked Bundle`} />
            <div>
                <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit} validationSchema={SymetricalBundleValidation(isRootUser)}>
                    {({}) => (
                        <Form>
                            <div className={allDeviceClasses.InputContainer}>
                                <div className={allDeviceClasses.FieldControl2}>
                                    <label htmlFor="name">
                                        Name
                                        <span className="required">*</span>
                                    </label>
                                    <Input name="name" id="name" style={{ marginTop: '0' }} />
                                </div>
                                {isRootUser && (
                                    <div className={allDeviceClasses.FieldControl2}>
                                        <label htmlFor="admin">
                                            Admin <span className="required">*</span>
                                        </label>
                                        <div>
                                            <Dropdown name={`adminId`} options={admins || []} defaultValue={selectedAdmin} onChange={setSelectedAdmin} />
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className={allDeviceClasses.InputContainer}>
                                <div className={allDeviceClasses.FieldControl2}>
                                    <label htmlFor="market">
                                        Market <span className="required">*</span>
                                    </label>
                                    <div>
                                        <Dropdown name={`market`} options={MARKET_OPTION} defaultValue={selectedMarket} onChange={setSelectedMarket} />
                                    </div>
                                </div>
                                <div className={allDeviceClasses.FieldControl2}>
                                    <label htmlFor="area">
                                        Area <span className="required">*</span>
                                    </label>
                                    <div>
                                        <Dropdown name={`area`} options={AREA_OPTION} defaultValue={selectedArea} onChange={setSelectedArea} />
                                    </div>
                                </div>
                            </div>
                            <div className={allDeviceClasses.InputContainer}>
                                <div className={allDeviceClasses.FieldControl2}>
                                    <label htmlFor="type">
                                        Type <span className="required">*</span>
                                    </label>
                                    <div>
                                        <Dropdown name={`type`} options={TYPE_OPTION} defaultValue={selectedType} onChange={setSelectedType} />
                                    </div>
                                </div>
                                <div className={allDeviceClasses.FieldControl2}>
                                    <label htmlFor="incInstanceBundle">
                                        INC Instance Bundles <span className="required">*</span>
                                    </label>
                                    <MultiSelectDropdown name="incInsBundles" options={incInsBundles} defaultValue={selectedIncInsBundles} />
                                </div>
                            </div>

                            <div className={allDeviceClasses.InputContainer}>
                                <div className={allDeviceClasses.FieldControl2}>
                                    <label htmlFor="decInstanceBundle">
                                        DEC Instance Bundles <span className="required">*</span>
                                    </label>
                                    <MultiSelectDropdown name="decInsBundles" options={decInsBundles} defaultValue={selectedDecInsBundles} />
                                </div>
                                <div className={allDeviceClasses.FieldControl2}></div>
                            </div>

                            <div className={allDeviceClasses.ButtonContainer}>
                                <div
                                    onClick={() => {
                                        setOpen({ status: false, editBundle: null });
                                    }}
                                >
                                    <button type="button" className="btn-secondary">
                                        Cancel
                                    </button>
                                </div>
                                <div>
                                    <button type="submit" className="btn-primary">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
